export default {
  baseUrl: process.env.REACT_APP_BASE_API_URL,
  mailBoxDomain: process.env.REACT_APP_BASE_MAILBOX_DOMAIN,
  projectName: process.env.REACT_APP_PROJECT_NAME,
  authUrl: process.env.REACT_APP_AUTH_URL,
  appInsights: process.env.REACT_APP_INSIGHTS_KEY,
  podUrl: process.env.REACT_APP_POD_URL,
  clientPortalBaseDomain: process.env.REACT_APP_CLIENT_PORTAL_BASE_DOMAIN,
};
